<template>
	<div class="card review-item">
		<div class="columns column3">
			<span class="review-score">
				<font-awesome-icon
					v-for="(icon, index) in ratingToStars(item.rating)"
					:key="`${item.ID}-${icon}-${index}`"
					:icon="`fa ${icon}`"
					size="1x"
				/>
			</span>
			<p>
				<strong>{{ item.firstName }}</strong>
				<br />
				<span>{{ item.country }}</span>
				<br />
				<span>{{ $d(new Date(item.date.date.split(' ')[0]), 'short') }}</span>
			</p>
			<div class="logo" :class="item.source" />
		</div>
		<div class="columns column9">
			<h2>{{ item.header }}</h2>
			<p>{{ item.content }}</p>
		</div>
	</div>
</template>

<script setup>
defineProps({
	item: { type: Object, default: () => {} },
});

const ratingToStars = (rating) => {
	const fullStars = parseInt(rating / 2, 10);
	const result = Array(fullStars).fill('fa-star');

	if ((rating / 2) % 1 !== 0) {
		result.push('fa-star-half');
	}

	return result;
};
</script>

<style lang="scss" scoped>
.review-item {
	background: #fff;
	margin: 20px auto 60px;
	box-shadow: 0 20px 30px rgb(0 0 0 / 5%);
	padding: 50px;
	display: flex;
	flex-flow: wrap row;
	justify-content: space-between;
	align-items: center;

	img {
		max-width: 100px;
		margin: 0;
	}

	.review-score {
		color: #f67c01;
		margin: 15px 0 0;
		display: inline-block;
	}

	.logo {
		width: 75px;
		height: 50px;
		background-size: 75px 50px;

		&.tripadvisor {
			background-image: url('~/assets/images/review-logo-tripadvisor.png');
		}

		&.bookingcom {
			background-image: url('~/assets/images/review-logo-bookingcom.png');
		}

		&.zoover {
			background-image: url('~/assets/images/review-logo-zoover.png');
		}

		&.expedia {
			background-image: url('~/assets/images/review-logo-expedia.png');
		}

		&.google {
			background-image: url('~/assets/images/review-logo-google.png');
		}
	}
}

@media (max-width: 960px) {
	.review-item {
		flex-flow: wrap column-reverse;
		padding: 30px 5px;
		width: 92%;

		.column3 {
			width: 100%;
		}
	}
}
</style>
